function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.267 13.89l.625-.625a.389.389 0 000-.538L2.178 7l5.714-5.728a.389.389 0 000-.538L7.267.108a.388.388 0 00-.538 0L.109 6.731a.389.389 0 000 .538l6.62 6.624a.388.388 0 00.538-.002z",
  fill: "#231F20"
});

function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    fill: "none"
  }, props), _ref);
}

export default SvgChevronLeft;